/* global axios */

import ApiClient from './ApiClient';

class GoogleSheetsAPI extends ApiClient {
  constructor() {
    super('google_sheets', { accountScoped: true });
  }

  // Inicia o fluxo OAuth
  authorize() {
    return axios.post(`${this.url}/authorization`);
  }

  // Verifica status da conexão
  getStatus() {
    return axios.get(`${this.url}/authorization/status`);
  }

  // Desconecta a conta Google
  disconnect() {
    return axios.delete(`${this.url}/authorization`);
  }

  // Salva configuração OAuth (Client ID e Client Secret)
  saveConfig(clientId, clientSecret) {
    return axios.post(`${this.url}/authorization/config`, {
      client_id: clientId,
      client_secret: clientSecret,
    });
  }

  // Lista todas as planilhas do Drive
  listSpreadsheets(limit = 50) {
    return axios.get(`${this.url}/spreadsheets`, {
      params: { limit },
    });
  }

  // Lista as abas de uma planilha
  listSheets(spreadsheetId) {
    return axios.get(`${this.url}/spreadsheets/${spreadsheetId}/sheets`);
  }

  // Obtém as colunas (headers) de uma aba
  getColumns(spreadsheetId, sheetName) {
    return axios.get(`${this.url}/spreadsheets/${spreadsheetId}/columns`, {
      params: { sheet_name: sheetName },
    });
  }

  // Consulta dados de uma aba
  queryData(spreadsheetId, sheetName, options = {}) {
    const { maxRecords = 1000 } = options;

    return axios.post(`${this.url}/spreadsheets/${spreadsheetId}/query`, {
      sheet_name: sheetName,
      max_records: maxRecords,
    });
  }

  // Preview de dados (primeiras linhas)
  previewData(spreadsheetId, sheetName, limit = 10) {
    return axios.get(`${this.url}/spreadsheets/${spreadsheetId}/preview`, {
      params: {
        sheet_name: sheetName,
        limit,
      },
    });
  }
}

export default new GoogleSheetsAPI();
